__webpack_require__.p = "/spiral/";